import { ColumnConfig, CustomerCfaReportColumnKey } from '../../model';

export const cfaCustomerOrderReportConfig: Record<
  CustomerCfaReportColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.No',
  },
  productName: {
    name: 'Product Name',
    sortField: 'productname',
  },
  sku: {
    name: 'SKU',
  },
  orderQty: {
    name: 'Ordered Quantity',
    alignment: 'flex-end',
  },
  orderValue: {
    name: 'Order Value',
    alignment: 'flex-end',
  },
  noOfOrders: {
    name: 'Number of orders',
  },
  cfaName: {
    name: 'CFA',
  },
  orderDate: {
    name: 'Date',
    sortField: 'orderdate',
    isVisible: false,
  },
  customerName: {
    name: 'Customer',
    isVisible: false,
  },

  refOrderNumber: {
    name: 'Order Number',
    sortField: 'refordernumbers',
  },
  totalOrderValue: {
    name: 'Total Order Value',
    isVisible: false,
  },
  totalSku: {
    name: 'Total Sku Count',
    isVisible: false,
  },
  // totalOrders: {
  //   name: 'Total Orders',
  //   alignment: 'flex-end',
  // },
};
